import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HashRouter } from 'react-router-dom'
import 'lib-flexible'
import AutoScorllTop from './AutoTop';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <AutoScorllTop>{/*阻止页面切换时记住位置*/}
      <App />
    </AutoScorllTop>
  </HashRouter>
);